import { ArrowUpRightIcon } from "@heroicons/react/20/solid"
import Container from "./Container"
import { usePage } from "@inertiajs/react"

const PromotionsBanner = () => {
  const { featured_promotions } = usePage().props

  if (featured_promotions.length === 0) return null

  return (
    <div className="bg-gray-900" role="status" aria-live="polite">
      <Container className="flex flex-wrap items-center justify-center gap-x-8 py-2">
        <h3 className="text-center text-sm font-bold tracking-tight text-white uppercase">
          Promotions
        </h3>
        <div className="flex flex-wrap items-center justify-center gap-x-6 sm:gap-y-1">
          {featured_promotions.map((promotion) => (
            <a
              key={promotion.slug}
              href={`/p/${promotion.slug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center gap-x-1 py-2 text-gray-200 transition-colors hover:text-white sm:py-1"
            >
              <span className="text-center text-sm group-hover:underline">
                {promotion.title}
              </span>
              <ArrowUpRightIcon className="size-4" />
            </a>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default PromotionsBanner
